import GroupChannelListUI, {
  type GroupChannelListUIProps,
} from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListUI';
import { useGroupChannelListContext } from '@sendbird/uikit-react/GroupChannelList/context';
import { useCallback, useEffect } from 'react';
import { useForwardMessageContext } from '../ForwardMessageProvider';
import { GroupChannelListItem } from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListItem';
import { useLeaveChannel } from '../../../api/hooks/sendbird/useLeaveChannel';
import GroupChannelPreviewAction from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelPreviewAction';

export const GroupCustomChannelListUI = ({
  renderHeader,
}: GroupChannelListUIProps) => {
  const groupChannelListContext = useGroupChannelListContext();
  const shareMessageContext = useForwardMessageContext();
  const { mutateAsync: leaveChannelAsync } = useLeaveChannel();

  useEffect(() => {
    if (groupChannelListContext.initialized) {
      shareMessageContext.setGroupChannels(
        groupChannelListContext.groupChannels
      );
    }
  }, [
    groupChannelListContext.groupChannels,
    groupChannelListContext.initialized,
    shareMessageContext,
  ]);

  const handleLeaveChannel = useCallback(
    async (channelUrl: string) => {
      await leaveChannelAsync({ channelUrl });
    },
    [leaveChannelAsync]
  );

  return (
    <GroupChannelListUI
      renderHeader={renderHeader}
      renderChannelPreview={(props) => (
        <GroupChannelListItem
          {...props}
          renderChannelAction={(renderChannelActionProps) => {
            return (
              <GroupChannelPreviewAction
                {...renderChannelActionProps}
                onLeaveChannel={() =>
                  handleLeaveChannel(props.channel.url).catch(() => {
                    // Error handling is done in the hook, so we can ignore it here
                  })
                }
              />
            );
          }}
        />
      )}
    />
  );
};
